import { render } from "./AddSection.vue?vue&type=template&id=c1c99ec2&scoped=true"
import script from "./AddSection.vue?vue&type=script&lang=js"
export * from "./AddSection.vue?vue&type=script&lang=js"

import "./AddSection.vue?vue&type=style&index=0&id=c1c99ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c99ec2"]])

export default __exports__